import { Button, ComposedModal, ModalBody } from '@carbon/react';
import ModalStateManager from "../../Modal/index.js";

const LogoutModal = ({ isOpen, onClose, onLogout }) => {
  const modalService = ModalStateManager({
    children: (
      <ComposedModal
        className="logout-modal"
        open={isOpen}
        onClose={onClose}
        size="md"
      >
        <ModalBody>
          <div className="logout-modal__panel">
            <h2>¿Seguro que desea salir de la aplicación?</h2>

            <div className="logout-modal__actions">
              <Button kind="danger" size="md" onClick={onClose}>
                Cancelar
              </Button>

              <Button kind="primary" size="md" onClick={onLogout}>
                Salir
              </Button>
            </div>
          </div>
        </ModalBody>
      </ComposedModal>
    )
  });

  return modalService;
};

export default LogoutModal;